import React                from 'react';
import { Observe }          from 'rewire-core';
import { WithStyle }        from 'rewire-ui';
import { Theme }            from '@material-ui/core/styles';
import { withStyles }       from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '37px',
    minHeight: '37px',
    maxHeight: '37px',
    padding: '0px 8px',
    borderTop: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.dialogPrimary.main,
    color: theme.palette.navBarPrimary.main,
  },
});

interface IMainContentFooterProps {
}

type MainContentFooterProps = WithStyle<ReturnType<typeof styles>, IMainContentFooterProps>;

class MainContentFooter extends React.PureComponent<MainContentFooterProps> {
  constructor(props: MainContentFooterProps) {
    super(props);
  }

  render() {
    const {classes, children} = this.props;

    return <Observe render={() => {
      if (!children) {
        return null;
      }
      return (
        <div className={classes.root}>
          {children}
        </div>
      );
    }} />;
  }
}

export default withStyles<IMainContentFooterProps>(styles, MainContentFooter);
